import { Author } from 'src/models';
import { AutocompleteEmail, MemberResult } from 'src/models/autocomplete.model';

export function convertByEmailResultToShow(item: AutocompleteEmail): MemberResult {
  return { ...item, label: '' };
}

export function convertMemberToAuthor(m: AutocompleteEmail): Author {
  return { photo_url: m.picture, full_name: m.name };
}
